/**
 * About Hero Section
 * Hero section for the About Us page - fetched from CMS API
 */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import axios from 'axios';

const CMS_API_URL = process.env.REACT_APP_API_BASE_URL_CMS || '';
const ABOUT_US_UID = 'ABOUT-US-SACCOS';

const AboutHero = () => {
  const [heroData, setHeroData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch hero content from CMS API
  useEffect(() => {
    const fetchHeroContent = async () => {
      try {
        const response = await axios.post(
          `${CMS_API_URL}sections/get-by-uid`,
          { UID: ABOUT_US_UID },
          {
            headers: { 'Content-Type': 'application/json' },
            timeout: 30000,
          }
        );

        if (response.data?.code === 1 && Array.isArray(response.data?.data) && response.data.data.length > 0) {
          const data = response.data.data[0];
          // Only use if not deleted and published
          if (data.IsDeleted === false && data.IsPublished === true) {
            setHeroData({
              Title: data.Title,
              SubTitle: data.SubTitle,
              Description: data.Description,
            });
          }
        }
      } catch (error) {
        console.error('Failed to fetch about hero content:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchHeroContent();
  }, []);

  // Return null if no data from API after loading
  if (!loading && !heroData) {
    return null;
  }

  // Show loading skeleton while fetching data
  if (loading) {
    return (
      <section className="bg-[#2f3951] py-5 md:py-5">
        <div className="container mx-auto px-6 md:px-8 lg:px-12">
          <div className="h-6 w-32 bg-white/20 rounded mb-3 animate-pulse" />
          <div className="h-10 w-64 bg-white/20 rounded mb-2 animate-pulse" />
          <div className="w-24 h-1 bg-white/20 mb-3 animate-pulse" />
          <div className="h-4 w-96 bg-white/20 rounded animate-pulse" />
        </div>
      </section>
    );
  }

  return (
    <section className="bg-[#2f3951] py-5 md:py-5">
      <div className="container mx-auto px-6 md:px-8 lg:px-12">
        {/* Breadcrumb */}
        <nav className="flex items-center text-white/80 text-sm mb-3">
          <Link to="/" className="flex items-center hover:text-[#ca9a37] transition-colors">
            <Home className="w-4 h-4 mr-1" />
            Home
          </Link>
          <ChevronRight className="w-4 h-4 mx-2" />
          <span className="text-[#ca9a37]">About Us</span>
        </nav>

        {/* Title */}
        <h1 className="text-2xl md:text-4xl font-bold text-white mb-2">
          {heroData.Title}
        </h1>
        <div className="w-24 h-1 bg-[#ca9a37] mb-3"></div>

        <p className="text-base text-gray-200 max-w-2xl">
          {heroData.Description?.replace(/<[^>]*>/g, '')?.replace(/&nbsp;/g, ' ') || heroData.Description}
        </p>
      </div>
    </section>
  );
};

export default AboutHero;
